<!--
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-09-24 11:26:05
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-09-28 10:25:36
 * @FilePath: \crm-product\src\views\dms\views\order\b-free-product\table\table.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<script>
import TablePage from '@/found/components/table_page';
import request from '@/found/utils/request';
import Form from '../form/index';

export default {
  extends: TablePage,
  components: { Form },
  data() {
    return {
      formConfig: {},
      modalConfig: {
        title: '新增',
        visible: false,
        type: 'Modal',
      },
    };
  },
  async mounted() {
    await this.getConfigList('main-list');
  },

  methods: {
    modalClick({ val, row }) {
      if (val.code === 'add') {
        this.openAddModal();
      } else if (val.code === 'enable') {
        if (!this.selection.length) {
          this.$message('请至少选择一条数据！');
          return false;
        }
        request
          .post('/dms/dms/bFreeOrder/product/enable', this.selection)
          .then((res) => {
            if (res.success) {
              this.$message({
                type: 'success',
                message: '操作成功',
              });
              this.getList();
              this.clearSelection();
            }
          });
      } else if (val.code === 'disable') {
        if (!this.selection.length) {
          this.$message('请至少选择一条数据！');
          return false;
        }
        request
          .post('/dms/dms/bFreeOrder/product/disable', this.selection)
          .then((res) => {
            if (res.success) {
              this.$message({
                type: 'success',
                message: '操作成功',
              });
              this.getList();
              this.clearSelection();
            }
          });
      }
    },
    // 新增弹窗：内容由 add-list 配置的表格组成，勾选数据后确认提交（Drawer 底部自带确定/取消按钮）
    openAddModal() {
      this.formName = 'Form';
      this.modalConfig = {
        ...this.modalConfig,
        title: '新增',
        visible: true,
        type: 'Drawer',
        width: '80%',
        showFooter: true,
      };
    },
    // 弹窗确定：获取选中行提交数据
    onModalOk() {
      const rows = this.$refs.modalForm ? this.$refs.modalForm.selectRow : [];
      if (rows.length === 0) {
        this.$message.warning('请选择数据');
        return;
      }
      this.submitAdd(rows);
    },
    submitAdd(rows) {
      request
        .post(
          '/dms/dms/bFreeOrder/product/save',
          rows.map((v) => ({
            productCode: v.materialCode,
            productName: v.materialName,
            spec: v.specification,
          })),
        )
        .then((res) => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '操作成功',
            });
            this.getList();
            this.modalConfig.visible = false;
          }
        });
    },
  },
};
</script>
